module.exports = __webpack_public_path__ + "static/media/sel_01_277.f9f670a0.mp4";